import { useUserStore } from "~/stores/userStore"

export default defineNuxtRouteMiddleware((_to, _from) => {
  const userStore = useUserStore()
  if (!userStore.isTeacher && !userStore.isEklaseUser) {
    return navigateTo("/viedgramata")
  }
})
